import { MutableRefObject, useEffect, useState } from "react";
import labels from "../../utils/labels";
import LabeledSection from "../UI/LabeledSection";
import EmployeeTransportType from "./EmployeeTransportType";
import EmployeeWorktime from "./EmployeeWorkTime";
import EmployeeTeamMove from "./EmployeeTeamMove";
import { useAppSelector } from "../../store/hooks";
import useDataSelector from "../../hooks/useDataSelector";

const EmployeeSettingsTab = ({
  onEmployeeUnsavedEdit,
  onDeleteWorkTimeRequest,
  worktimeSaveRef,
  transportSaveRef,
}: {
  onEmployeeUnsavedEdit: (hasChanges: boolean) => void;
  onDeleteWorkTimeRequest: () => void;
  worktimeSaveRef?: MutableRefObject<(() => Promise<void>) | null>;
  transportSaveRef?: MutableRefObject<(() => Promise<void>) | null>;
}) => {
  const [hasWorktimeChanges, setHasWorktimeChanges] = useState(false);
  const [hasTransportChanges, setHasTransportChanges] = useState(false);
  const [isWorktimeSavePending, setIsWorktimeSavePending] = useState(false);
  const { employeeShiftId } = useAppSelector(
    (state) => state.drawerSlice.selectedEmployee!,
  );
  const { manualEdits } = useAppSelector(
    (state) => state.employeeSettingsSlice,
  );
  const { dataToUse } = useDataSelector();
  const employee = dataToUse?.employees.find(
    (e) => e.shiftSchedule.idShift === employeeShiftId,
  );

  const manualWorkTimeEdits =
    manualEdits[employeeShiftId]?.employeeWorkTime ??
    employee?.manualShiftChanges?.employeeWorkTime;

  const workTimeToUse = manualWorkTimeEdits ?? {
    workTimeStart: employee?.shiftStartTime ?? null,
    workTimeEnd: employee?.shiftEndTime ?? null,
  };

  const hasWorkTime =
    (workTimeToUse.workTimeStart != null ||
      workTimeToUse.workTimeEnd != null) &&
    workTimeToUse.workTimeStart !== workTimeToUse.workTimeEnd;

  const hasTransportData =
    (employee?.transportationType?.length ?? 0) > 0 ||
    (manualEdits[employeeShiftId]?.transportationType?.length ?? 0) > 0;

  useEffect(() => {
    onEmployeeUnsavedEdit(hasWorktimeChanges || hasTransportChanges);
  }, [hasWorktimeChanges, hasTransportChanges, onEmployeeUnsavedEdit]);

  return (
    <>
      {/* daily settings */}
      <LabeledSection title={labels.dailySettings}>
        <EmployeeWorktime
          hasWorkTime={hasWorkTime}
          onUnsavedEdit={setHasWorktimeChanges}
          onDeleteWorkTimeRequest={onDeleteWorkTimeRequest}
          saveRef={worktimeSaveRef}
          onPendingChange={setIsWorktimeSavePending}
        />
        {hasWorkTime && hasTransportData && !isWorktimeSavePending && (
          <EmployeeTransportType
            onUnsavedEdit={setHasTransportChanges}
            saveRef={transportSaveRef}
          />
        )}
        <EmployeeTeamMove />
      </LabeledSection>

      {/* permanent settings */}
      {/* <LabeledSection title={labels.permanentSettings}>
        <p>settings...</p>
      </LabeledSection> */}
    </>
  );
};

export default EmployeeSettingsTab;
